import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import cancelGif from "../assets/icons/cancel.gif";

const Cancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    // Si session_id absent (par ex. après un refresh), rediriger
    if (!sessionId) {
      console.warn("Session ID manquant, redirection vers EspaceClient");
      navigate("/EspaceClient", { replace: true });
    }
  }, [sessionId, navigate]);

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-white text-color1 text-center p-4">
      <img src={cancelGif} alt="Paiement échoué" className="w-40 h-40 mb-6" />
      <h1 className="text-4xl font-bold mb-4">Paiement échoué </h1>
      <p className="text-lg mb-6 max-w-md">
        Votre paiement n’a pas pu être confirmé. Veuillez réessayer ou contacter le support si le problème persiste.
      </p>
      <button
        onClick={() => navigate("/EspaceClient")}
        className="px-6 py-3 bg-color1 text-color2 rounded-lg text-lg font-semibold hover:opacity-90 transition"
      >
        Retour vers dashboard
      </button>
    </div>
  );
};

export default Cancel;
